import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { copyToClipboard } from "../../utils";

export default function Contacts() {
    const { t, i18n } = useTranslation();

    const copyPhone = useCallback(() => {
        try {
            copyToClipboard(t("phone").replaceAll(" ", ""));
            toast(t("Numéro de téléphone copié!", "Phone number copied!"));
        } catch (ex) {
            console.warn("Copy to clipboard failed.", ex);
            return prompt("Copy to clipboard: Ctrl+C, Enter", t("phone"));
        }
    }, [t]);

    return (
        <div id="contacts" className="flex-1 shadow-xl">
            <div
                className="shadow-white bg-[#343a40]
			grid grid-cols-3 gap-4 py-10 px-20
			max-lg:flex max-lg:flex-col max-lg:px-10
			"
            >
                <a
                    className="flex hover:text-shadow hover:scale-110"
                    href="mailto:thibaut.herbet@gmail.com"
                >
                    <i className="bi bi-envelope-at text-2xl"></i>
                    <span className="grow text-center my-auto">
                        thibaut.herbet@gmail.com
                    </span>
                </a>
                <a
                    className="flex hover:text-shadow hover:scale-110"
                    href="https://github.com/thvent"
                >
                    <i className="bi bi-github text-2xl"></i>
                    <span className="grow text-center my-auto">Github</span>
                </a>
                <button
                    className="flex hover:text-shadow hover:scale-110"
                    onClick={copyPhone}
                >
                    <i className="bi bi-phone text-2xl"></i>
                    <span className="grow text-center my-auto">
                        {t("phone")}
                    </span>
                </button>
                <a
                    className="flex hover:text-shadow hover:scale-110"
                    href="https://www.linkedin.com/in/thibaut-herbet/"
                >
                    <i className="bi bi-linkedin text-2xl"></i>
                    <span className="grow text-center my-auto">LinkedIn</span>
                </a>
                <div className="flex">
                    <i className="bi bi-geo-alt text-2xl"></i>
                    <span className="grow text-center my-auto">
                        Lens, Arras, Lille
                    </span>
                </div>
                <a
                    className="flex hover:text-shadow hover:scale-110"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`./docs/thibaut-herbet-cv-${i18n.language}.pdf`}
                >
                    <i className="bi bi-file-pdf text-2xl"></i>
                    <span className="grow text-center my-auto">
                        Curriculum Vitae
                    </span>
                </a>
            </div>
        </div>
    );
}
